import { mutateTeams } from '../../mutations/mutateTeams';
import { organizationAPI } from 'api/phases/endpoints';

export const removeTeam = async (teamId: number) => {
  await organizationAPI.deleteTeam(teamId);
  await mutateTeams();
};
